module.exports = __webpack_public_path__ + "assets/cbad2615d1b641628104cdb11f365ced.mp3";